import { call, put, select } from 'redux-saga/effects';
import { setSecretKeyCommunication } from '../../../effects/organization';
import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* getSecretKeyCommunication({ payload }) {
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${dpaApiBaseUrl + RESOURCES.V2}/applications/${
    payload.appId
  }/secret?api=IAPI`;
  const { success, error, result } = yield call(callAPI, {
    url,
    method: METHODS.GET,
  });

  if (success && !error) {
    yield put(
      setSecretKeyCommunication({
        appId: payload.appId,
        appSecret: result.appSecret,
      }),
    );
  } else {
    console.error(error);
  }
}
